import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = {
    key: 0,
    class: "flex items-center"
};
const _hoisted_3 = ["src", "alt"];
const _hoisted_4 = { class: "ml-2" };
const _hoisted_5 = ["src", "alt"];
export default /*#__PURE__*/ _defineComponent({
    __name: 'DocumentIcon',
    props: {
        projectFile: Object
    },
    emits: ["onReadItem", "onRedirect", "onDownload"],
    setup(__props, { emit: emits }) {
        const props = __props;
        const readItem = () => {
            const file = props.projectFile;
            if (file.extension === 'xml') {
                emits('onRedirect', file);
            }
            else if (file.extension === 'pdf') {
                emits('onDownload', file);
            }
            else {
                emits('onReadItem', file);
            }
        };
        return (_ctx, _cache) => {
            var _a;
            return (typeof __props.projectFile !== 'undefined' && __props.projectFile.hasOwnProperty('actionlink'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (__props.projectFile.actionlink === false)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createElementVNode("img", {
                                src: __props.projectFile.imagedata,
                                alt: __props.projectFile.filename
                            }, null, 8, _hoisted_3),
                            _createElementVNode("span", _hoisted_4, _toDisplayString(__props.projectFile.basename), 1)
                        ]))
                        : (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            onClick: _cache[0] || (_cache[0] = ($event) => (readItem())),
                            class: "flex items-center cursor-pointer"
                        }, [
                            _createElementVNode("img", {
                                src: __props.projectFile.imagedata,
                                alt: __props.projectFile.filename
                            }, null, 8, _hoisted_5),
                            _createElementVNode("span", {
                                class: _normalizeClass(["ml-2", { 'text-green': (_a = __props.projectFile.flag) !== null && _a !== void 0 ? _a : false }])
                            }, _toDisplayString(__props.projectFile.basename), 3)
                        ]))
                ]))
                : _createCommentVNode("", true);
        };
    }
});
